import MainLoading from "@/components/(loadings)/MainLoading";

export default function Loading() {
  return (
    <main className="flex h-svh items-center justify-center">
      <MainLoading />
    </main>
  );
}
